<template lang="html">

  <header class="header" :min="minmenu">

    <div class="top">

      <div class="container row-between">

      
      <div class="contenedor-logo">
        <router-link to="/">
          <img src="/static/img/UFV-logo.png" alt="UFV">
        </router-link>
      </div>
      
      <button class="show-menu" aria-labed="Ver menú" @click="showmenu = true">
        <span></span>
        <span></span>
        <span></span>
      </button>

    </div>
      
    </div>


    <nav class="menu column-start" :show="showmenu">

      <a class="close" @click="showmenu = false">✕</a>

      <router-link to="/">Inicio</router-link>
      <div class="group" :show="showalumni" @mouseleave="showalumni = false">
        <router-link @mouseover.native="showalumni = true" class="with-arrow" :to="$t('enlaces.alumnos')">
          Alumnos y alumni
        </router-link>
        <span @click="showalumni = !showalumni"></span>
        <div class="links" :show="showalumni">
          <router-link class="small" :to="$t('enlaces.orientacion')">Orientación</router-link>
          <router-link class="small" :to="$t('enlaces.internacional')">Internacional</router-link>
          
        </div>
      </div>
      <router-link :to="$t('enlaces.empresas')">Empresas</router-link>
      <router-link :to="$t('enlaces.observatorio')">Observatorio de empleo</router-link>
      <router-link :to="$t('enlaces.aldia')">Al día</router-link>
      <router-link :to="$t('enlaces.conectados')">Conecta2</router-link>
      <router-link :to="$t('enlaces.contacto')">Contacto</router-link>
    </nav>

  </header>

</template>

<script lang="js">
  export default  {
    name: 'app-header',
    data() {
      return {
        showalumni : false,
        showguia : false,
        showmenu : false,
        minmenu : false
      }
    },
    mounted(){
      this.checkMinMenu();

      $(window).scroll(e => {
        this.checkMinMenu();
      })
    },
    methods : {
      checkMinMenu(){
        this.minmenu = ($(window).scrollTop() > 100);
      }
    },
    watch : {
      '$route'(){
        this.showmenu = false;
      }
    },
    computed : {
      showlogo(){
        let hidein = ['home'];

        return hidein.some(e => e != this.$route.name);
        
      }
    }
    
}
</script>

<style scoped>
  .header {

  }
</style>



// WEBPACK FOOTER //
// src/components/parts/header.vue